// Definicao dos 6 steps do Tour Guiado.
//
// Estrutura escalavel: adicionar 7o step = nova entrada neste array
// + nova chave em `progress` no localStorage (handled pelo provider).
//
// Textos atuais sao PLACEHOLDERS — designer substitui na etapa CODE+FIGMA.
// Limite informal: ate 240 caracteres por description.
//
// requiredPermission: chave de profile.permissions necessaria para o user
// poder acessar a area. Steps que o user nao tem permissao ficam fora do
// ProgressCard, do allCompleted e do allHintsSeen — ele so ve o que pode usar.

export const TOUR_STEP_IDS = [
    "corporate_card",
    "mileage",
    "cost_center",
    "category",
    "users",
    "credits",
];

export const TOUR_STEPS = [
    {
        id: "corporate_card",
        title: "Cartão Corporativo",
        description:
            "No Zag você pode habilitar a opção de Cartão Corporativo para que usuários lancem suas despesas pagas pela empresa, sem necessidade de reembolso.", // TODO designer
        icon: "/img/configuracoes.svg",
        route: "/settings?section=corporate-card",
        detector: { type: "settings_section", value: "corporate-card" },
        dataTour: "corporate-card",
        requiredPermission: "companySettings",
    },
    {
        id: "mileage",
        title: "Quilometragem",
        description:
            "Configure o valor por km rodado e habilite o reembolso por trajeto, com calculo automático no aplicativo, assim os usuários terão a opção de solicitar reembolso por KM, além de R$.", // TODO designer
        icon: "/img/configuracoes.svg",
        route: "/settings?tab=mileage",
        detector: { type: "settings_tab", value: "mileage" },
        dataTour: "mileage",
        requiredPermission: "companySettings",
    },
    {
        id: "cost_center",
        title: "Centro de Custo",
        description:
            "Crie Centros de custo para organizar despesas por área, projeto ou departamento e gerar relatórios consolidados. Controle em cada usuário ou administradores, quais Centros de Custo terá acesso.", // TODO designer
        icon: "/img/configuracoes.svg",
        route: "/settings?tab=projects",
        detector: { type: "settings_tab", value: "projects" },
        dataTour: "cost-center",
        requiredPermission: "companySettings",
    },
    {
        id: "category",
        title: "Categoria",
        description:
            "Além dos Centros de Custo, defina categorias de despesa com limite de valor para padronizar lançamentos e aplicar regras de aprovação automática. Controle em cada usuário ou administradores, quais Categorias terá acesso.", // TODO designer
        icon: "/img/configuracoes.svg",
        route: "/settings?tab=categories",
        detector: { type: "settings_tab", value: "categories" },
        dataTour: "category",
        requiredPermission: "companySettings",
    },
    {
        id: "users",
        title: "Usuários",
        description:
            "Faça a gestão completa de seus usuários e administradores. Convide pessoas, defina papéis e restrinja acessos à Categorias e Centros de custo específicos. Faça inclusão e exclusão, ativação ou inativação unitária ou em lote, além de se for proprietário(a) da empresa, você pode gerar novas senhas de acesso para cada um usuário quando necessário. ", // TODO designer
        icon: "/img/usuarios.svg",
        route: "/users",
        detector: { type: "route", value: "/users" },
        dataTour: "users",
        requiredPermission: "users",
    },
    {
        id: "credits",
        title: "Créditos",
        description:
            "Gerencie a caixinha ou adiantamento de dinheiro: Por aqui você pode registrar qualquer saldo previamente pago aos seus colaboradores e também, adicionar e retirar créditos em dinheiro, assim a a cada despesa o desconto é automático.", // TODO designer
        icon: "/img/creditos.svg",
        route: "/credits",
        detector: { type: "route", value: "/credits" },
        dataTour: "credits",
        requiredPermission: "credits",
    },
];

// Filtra TOUR_STEPS pelas permissoes do profile do usuario.
// Step sem requiredPermission e sempre incluido. Step com requiredPermission
// so entra se profile.permissions[chave] for truthy.
export const filterStepsByPermissions = (permissions) => {
    if (!permissions) return [];
    return TOUR_STEPS.filter(
        (step) =>
            !step.requiredPermission || !!permissions[step.requiredPermission]
    );
};

export const findStepByLocation = (pathname, search) => {
    const params = new URLSearchParams(search || "");
    const tab = params.get("tab");
    const section = params.get("section");

    return TOUR_STEPS.find((step) => {
        if (step.detector.type === "route") {
            return pathname === step.detector.value;
        }
        if (step.detector.type === "settings_tab") {
            return pathname === "/settings" && tab === step.detector.value;
        }
        if (step.detector.type === "settings_section") {
            return pathname === "/settings" && section === step.detector.value;
        }
        return false;
    });
};

export const findStepById = (stepId) =>
    TOUR_STEPS.find((step) => step.id === stepId);
